
/* --- Prekes galerija telefone: nuotrauku skaitiklis (1/12) --------------
   Telefone rodykles pasleptos, todel klientui neaisku, kad nuotrauku daugiau.
   Pridedam nedideli skaitikli, kuris atsinaujina slenkant.                 */
(function () {
  function mount(slides) {
    if (slides.dataset.nwCount) return;
    var n = slides.children.length;
    if (n < 2) return;
    var host = slides.closest('slideshow-component') || slides.parentElement;
    if (!host) return;
    slides.dataset.nwCount = '1';
    if (getComputedStyle(host).position === 'static') host.style.position = 'relative';
    var el = document.createElement('span');
    el.className = 'nw-galcount';
    el.setAttribute('aria-hidden', 'true');
    host.appendChild(el);
    function upd() {
      var w = slides.clientWidth || 1;
      var i = Math.round(slides.scrollLeft / w) + 1;
      if (i < 1) i = 1; if (i > n) i = n;
      el.textContent = i + ' / ' + n;
    }
    upd();
    slides.addEventListener('scroll', function () {
      if (el._t) cancelAnimationFrame(el._t);
      el._t = requestAnimationFrame(upd);
    }, { passive: true });
  }
  function scan() {
    document.querySelectorAll('media-gallery slideshow-slides').forEach(mount);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', scan);
  else scan();
  new MutationObserver(scan).observe(document.documentElement, { childList: true, subtree: true });
})();

/* --- Prekiu korteles: braukimas per nuotraukas telefone -------------------
   Temos karusele braukima gaudo per `mousedown`, o liesimo ekrane toks
   ivykis atsiranda tik po bakstelejimo, ne braukiant. Todel telefone
   nuotrauku perjungti nepavykdavo, nors kompiuteryje veike.
   Cia pridedam tikra pointer/touch braukima: horizontalus judesys slenka
   karusele ir prilimpa prie artimiausios skaidres, vertikalus - paliekamas
   puslapio slinkimui, o po braukimo neatidaromas gaminio puslapis.       */
(function () {
  function setup(scroller) {
    if (scroller.dataset.nwSwipe) return;
    scroller.dataset.nwSwipe = '1';

    var startX = 0, startY = 0, startLeft = 0;
    var active = false, horiz = false, moved = 0, pid = null;

    function loose() {
      scroller.style.scrollSnapType = 'none';
      scroller.style.scrollBehavior = 'auto';
    }
    function restore() {
      scroller.style.scrollSnapType = '';
      scroller.style.scrollBehavior = '';
    }

    scroller.addEventListener('pointerdown', function (e) {
      if (e.pointerType === 'mouse') return;
      if (scroller.scrollWidth <= scroller.clientWidth + 4) return;
      active = true; horiz = false; moved = 0; pid = e.pointerId;
      startX = e.clientX; startY = e.clientY; startLeft = scroller.scrollLeft;
    }, { passive: true });

    scroller.addEventListener('pointermove', function (e) {
      if (!active || e.pointerId !== pid) return;
      var dx = e.clientX - startX, dy = e.clientY - startY;
      if (!horiz) {
        if (Math.abs(dx) < 6 && Math.abs(dy) < 6) return;
        if (Math.abs(dx) <= Math.abs(dy)) { active = false; return; }
        horiz = true; loose();
        try { scroller.setPointerCapture(e.pointerId); } catch (err) {}
      }
      if (e.cancelable) e.preventDefault();
      moved = Math.abs(dx);
      scroller.scrollLeft = startLeft - dx;
    });

    /* Prilipimas prie TIKRŲ kortelių pozicijų (offsetLeft), o ne aritmetikos.
       Anksčiau buvo `idx * scroller.clientWidth` — karuselė šokdavo per visą
       ekraną, o kraštinis tarpas (gutters) buvo ignoruojamas, todėl kortelė
       likdavo perkirsta. */
    function stops() {
      var kids = Array.prototype.slice.call(scroller.children);
      if (!kids.length) return [0];
      var base = kids[0].offsetLeft;
      var max = scroller.scrollWidth - scroller.clientWidth;
      return kids.map(function (k) {
        return Math.max(0, Math.min(k.offsetLeft - base, max));
      });
    }
    function nearest(list, v) {
      var bi = 0, bd = Infinity;
      for (var i = 0; i < list.length; i++) {
        var d = Math.abs(list[i] - v);
        if (d < bd) { bd = d; bi = i; }
      }
      return bi;
    }
    function restoreLater() {
      var done = function () {
        restore();
        scroller.removeEventListener('scrollend', done);
      };
      if ('onscrollend' in window) scroller.addEventListener('scrollend', done);
      else setTimeout(done, 500);
    }

    function finish(e) {
      if (!active) return;
      active = false;
      if (!horiz) return;
      var pts = stops();
      var dx = (e && e.clientX != null ? e.clientX : startX) - startX;
      var idx = nearest(pts, startLeft);
      var pitch = pts.length > 1 ? Math.abs(pts[1] - pts[0]) : (scroller.clientWidth || 1);
      if (Math.abs(dx) > pitch * 0.2) idx += (dx < 0 ? 1 : -1);
      idx = Math.max(0, Math.min(idx, pts.length - 1));
      restoreLater();
      scroller.scrollTo({ left: pts[idx], behavior: 'smooth' });
      if (moved > 8) {
        var kill = function (ev) { ev.preventDefault(); ev.stopPropagation(); };
        scroller.addEventListener('click', kill, { capture: true, once: true });
        setTimeout(function () { scroller.removeEventListener('click', kill, true); }, 500);
      }
      horiz = false;
    }

    scroller.addEventListener('pointerup', finish);
    scroller.addEventListener('pointercancel', function () { active = false; horiz = false; restore(); });
  }

  /* Kas gauna mūsų braukimą:
       - kortelės nuotraukų galerija TINKLELYJE (pagrindinis, kolekcijos) -> TAIP;
       - viskas, kas yra horizontalioje karuselėje -> NE.

     Kodėl NE karuselėje: temos karuselė telefone slenkasi pati (overflow-x:
     scroll + CSS scroll-snap). Anksčiau ji neveikė todėl, kad pirštas beveik
     visada guli ant kortelės nuotraukos, o tai galerijai buvo uždėtas
     `touch-action: pan-y` — naršyklė horizontalaus judesio nebeperduodavo
     karuselei. Dabar galerija karuselėje horizontaliai neslenka iš viso,
     todėl judesys natūraliai nueina karuselei (Lukas, 2026-09-03). */
  function scan() {
    document.querySelectorAll('.product-card slideshow-slides, .nw-card__media')
      .forEach(function (el) {
        if (el.closest('.resource-list__carousel')) return;
        setup(el);
      });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', scan);
  else scan();
  new MutationObserver(scan).observe(document.documentElement, { childList: true, subtree: true });
})();


/* Aprašymo, proceso ir atsiliepimų blokai gyvena nw-cart.js — čia jie
   buvo dubliuoti du kartus ir kiekvienas kabino savo MutationObserver
   ant viso dokumento. Pašalinta 2026-09-02 (telefone stringdavo slinkimas). */

/* --- Pagrindinio puslapio kortelės: taškiukai po nuotraukomis -------------
   Rodo, kurioje nuotraukoje esame. Veikia tik telefone (CSS taškiukus
   kompiuteryje slepia), atnaujinama slenkant.                            */
(function () {
  function sync(scroller) {
    var wrap = scroller.parentElement;
    if (!wrap) return;
    var dots = wrap.querySelector('.nw-card__dots');
    if (!dots) return;
    var kids = dots.children;
    if (!kids.length) return;
    var w = scroller.clientWidth || 1;
    var i = Math.round(scroller.scrollLeft / w);
    if (i < 0) i = 0;
    if (i > kids.length - 1) i = kids.length - 1;
    for (var k = 0; k < kids.length; k++) {
      kids[k].classList.toggle('is-on', k === i);
    }
  }
  function bind(scroller) {
    if (scroller.dataset.nwDots) return;
    scroller.dataset.nwDots = '1';
    sync(scroller);
    var t = 0;
    scroller.addEventListener('scroll', function () {
      if (t) return;
      t = setTimeout(function () { t = 0; sync(scroller); }, 60);
    }, { passive: true });
  }
  function scan() {
    document.querySelectorAll('.nw-card__media').forEach(bind);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', scan);
  else scan();
  new MutationObserver(scan).observe(document.documentElement, { childList: true, subtree: true });
})();
